import listViewStore from 'owa-mail-list-store/lib/store/Store';
import * as undoActions from 'owa-mail-undo';
import { action } from 'satcheljs/lib/legacy';
import { getFocusedFilterForTable, isItemOfMessageType } from 'owa-mail-list-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazyLogCustomDataLoggerDatapoint } from 'owa-analytics';
import { lazyBuildInferenceDatapoint } from 'owa-mail-inference-tracking';
import datapoints from '../datapoints';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import mailStore from 'owa-mail-store/lib/store/Store';
import setItemsInferenceClassificationService from 'owa-mail-triage-action/lib/services/setItemsInferenceClassificationService';
/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
export default action('moveItemsToFocusedOrOther', datapoints.moveConversationToFocusedOrOther)(function moveItemsToFocusedOrOther(itemRowKeys, tableViewId, actionSource) {
    var tableView = listViewStore.tableViews.get(tableViewId);
    var focusedViewFilter = getFocusedFilterForTable(tableView);
    var isFocusedView = focusedViewFilter == 0 /* Focused */;
    var itemIdStrings = getRowIdsFromRowKeys(itemRowKeys, tableViewId);
    undoActions.clearLastUndoableAction();
    var itemContexts = itemIdStrings.map(function (itemIdValue) {
        var item = mailStore.items.get(itemIdValue);
        var isReadValue;
        if (isItemOfMessageType(item)) {
            isReadValue = item.IsRead;
        }
        else {
            // Default to isRead = true when not a mail item
            isReadValue = true;
        }
        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
            isRead: isReadValue,
        };
    });
    setItemsInferenceClassificationService(itemIdStrings, isFocusedView ? 'Other' : 'Focused');
    // Dispatch action to update the store state
    deleteItemsStoreUpdate(itemContexts, tableView.tableQuery.folderId);
    if (isMailFeatureEnabled('tri-nonSubstrateInference')) {
        var activityTime_1 = new Date().toISOString();
        lazyBuildInferenceDatapoint.import().then(function (buildInferenceDatapoint) {
            lazyLogCustomDataLoggerDatapoint.importAndExecute(buildInferenceDatapoint(tableView.serverFolderId, focusedViewFilter, activityTime_1, isFocusedView ? "MarkAsOther" /* MarkAsOther */ : "MarkAsFocused" /* MarkAsFocused */, itemIdStrings));
        });
    }
});
//# sourceMappingURL=moveItemsToFocusedOrOther.js.map